import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {ModalModule} from 'ngb-modal';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoaderComponent} from './loader/loader.component';
import { ReservationCardComponent } from './reservation-card/reservation-card.component';
import { HeaderComponent } from './header/header.component';
import { RestaurantSelectModalComponent } from './restaurant-select-modal/restaurant-select-modal.component';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import { ReservationCardSmallComponent } from './reservation-card-small/reservation-card-small.component';
import { ReservationNoteComponent } from './reservation-note/reservation-note.component';
import { ReservationCardEditComponent } from './reservation-card-edit/reservation-card-edit.component';
import { ReservationCardUserdataComponent } from './reservation-card-userdata/reservation-card-userdata.component';
import {AngularMultiSelectModule} from 'angular2-multiselect-dropdown';
import { DailySumComponent } from './daily-sum/daily-sum.component';
import { ImageModalComponent } from './image-modal/image-modal.component';


@NgModule({
  declarations: [LoaderComponent, ReservationCardComponent, HeaderComponent, RestaurantSelectModalComponent, ReservationCardSmallComponent, ReservationNoteComponent, ReservationCardEditComponent, ReservationCardUserdataComponent, DailySumComponent, ImageModalComponent],
  exports: [LoaderComponent, ReservationCardComponent, HeaderComponent, RestaurantSelectModalComponent, ReservationCardSmallComponent, ReservationNoteComponent, ReservationCardEditComponent, ReservationCardUserdataComponent],
    imports: [
        CommonModule,
        TranslateModule,
        ModalModule,
        FormsModule,
        TooltipModule,
        ReactiveFormsModule,
        AngularMultiSelectModule
    ]
})
export class ComponentsModule {
}
